import React, { createContext } from 'react';
import type { dh } from '@deephaven/jsapi-types';
import useCreateClient from './useCreateClient';

export const ClientContext = createContext<dh.CoreClient | null>(null);
ClientContext.displayName = 'ClientContext';

export type ClientBootstrapProps = {
  /** URL of the server to connect to */
  serverUrl: string;

  /** Connection options to pass to CoreClient when connecting */
  options?: dh.ConnectOptions;

  /**
   * The children to render wrapped with the ClientContext.
   * Will not render children until the client is created.
   */
  children: React.ReactNode;
};

/**
 * ClientBootstrap component. Handles creating the client.
 */
export function ClientBootstrap({
  serverUrl,
  options,
  children,
}: ClientBootstrapProps): JSX.Element {
  const client = useCreateClient(serverUrl, options);
  return (
    <ClientContext.Provider value={client}>{children}</ClientContext.Provider>
  );
}

export default ClientBootstrap;
